<template>
  <div class="new_exercise-no-task">
    <img class="img" :src="image" alt="">
    <p>今日暂无任务，休息下吧~</p>
  </div>
</template>

<script setup>
import NoTaskImg from "../img/no_task.png"
const image = NoTaskImg
</script>

<style lang="scss" scoped>
.new_exercise-no-task {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  border-radius: 0.12rem;
  padding: 0.46rem 0 0.48rem;
  .img {
    width: 2.28rem;
  }
  p {
    margin-top: 0.14rem;
    color: #969799;
    font-size: 0.28rem;
  }
}
</style>
